export default {
  time: {
    month: [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December",
    ],
    monthAbbr: [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
    ],
    dayOfWeek: [
      "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday",
    ],
    dayOfWeekAbbr: [
      "S", "M", "T", "W", "T", "F", "S",
    ],
  },
  legend: {
    selector: {
      all: "All",
      inverse: "Inverse",
    },
  },
  toolbox: {
    brush: {
      title: {
        rect: "Period selection",
        polygon: "Free selection",
        lineX: "Horizontal selection",
        lineY: "Vertical selection",
        keep: "Keep selected",
        clear: "Clear selected",
      },
    },
    dataView: {
      title: "Table view",
      lang: ["Table view", "Close", "Refresh"],
    },
    dataZoom: {
      title: {
        zoom: "Zoom",
        back: "Cancel zooming",
      },
    },
    magicType: {
      title: {
        line: "Change line graph",
        bar: "Change bar graph",
        stack: "Stack",
        tiled: "Tile",
      },
    },
    restore: {
      title: "Restore view",
    },
    saveAsImage: {
      title: "Save as a picture",
      lang: ["Right click to save"],
    },
  },
  series: {
    typeNames: {
      pie: "Pie chart",
      bar: "Bar chart",
      line: "Line chart",
      scatter: "Scatter chart",
      effectScatter: "Ripple scatter plot",
      radar: "Radar graph",
      tree: "Tree",
      treemap: "Tree map",
      boxplot: "Box plot",
      candlestick: "Candle",
      k: "K line graph",
      heatmap: "Heatmap",
      map: "Map",
      parallel: "Parallel line graph",
      lines: "Line graph",
      graph: "Relation graph",
      sankey: "Sankey graph",
      funnel: "Funnel graph",
      gauge: "Gauge",
      pictorialBar: "Pictorial bar graph",
      themeRiver: "Theme river graph",
      sunburst: "Sunburst graph",
      custom: "Custom graph",
      chart: "Chart graph",
    },
  },
  aria: {
    general: {
      withTitle: "Graph about \"{title}\"",
      withoutTitle: "Graph about",
    },
    series: {
      single: {
        prefix: "",
        withName: " with type {seriesType} named {seriesName}.",
        withoutName: " with type {seriesType}.",
      },
      multiple: {
        prefix: ". It consists of {seriesCount} series numbers.",
        withName: " {seriesId} is a series id {seriesType} which shows {seriesName}.",
        withoutName: " {seriesId} series is of type {seriesType}.",
        separator: {
          middle: "",
          end: "",
        },
      },
    },
    data: {
      allData: "Data is as follows: ",
      partialData: "First {displayCnt} items are: ",
      withName: "data {name} is {value}",
      withoutName: "{value}",
      separator: {
        middle: ", ",
        end: ". ",
      },
    },
  },
};
